import { Card, Col, Row, Skeleton, Tag, Typography } from "antd";
import WrapCenter from "../WrapCenter/WrapCenter";
import VerticalCenter from "../WrapCenter/VerticalCenter";
import { CompanyRole } from "src/entity/map-company-user/user-in-company";
import { User } from "src/entity/profile/user.entity";
import { ellipsis_text } from "src/theme/common";

const { Title } = Typography;
interface UserCardProps {
  user: User;
  companyRole: CompanyRole[];
}

const UserCard: React.FC<UserCardProps> = ({ user, companyRole }) => {
  return (
    <Card className="w-full cursor-pointer">
      <Row className="w-full">
        <Col span={4}>
          <VerticalCenter>
            <img
              alt="profile-img"
              src={`${process.env.REACT_APP_DEFAULT_IMG_URL}${user.name}`}
              className="rounded-[30px]"
              width={60}
              height={60}
            />
          </VerticalCenter>
        </Col>
        <Col span={20}>
          <Row justify={"space-between"} className="w-full">
            <Title level={4} style={{ fontWeight: "bold" }}>
              {user.name}
            </Title>
          </Row>

          {companyRole.length > 0 && (
            <Col span={24}>
              {companyRole.map((item, index) => {
                if (index === 0)
                  return (
                    <Row key={"roles-" + index}>
                      <Row className="w-full">
                        <div style={ellipsis_text} className="w-3/5">
                          Role :{"\u00A0"}
                          {item.roles.map((role, indexing) => {
                            return (
                              <strong key={"role-list" + indexing}>
                                {role.roleName}
                                {indexing === item.roles.length - 1 ? "" : `,\u00A0`}
                              </strong>
                            );
                          })}
                        </div>
                        {"\u00A0 in Company :\u00A0"} <strong>{item.companyName}</strong>
                      </Row>
                    </Row>
                  );
                else return <div key={"roles-empty-" + index}></div>;
              })}
            </Col>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default UserCard;
